<template>
	<div v-if="runtimeConfig.public.ENABLE_COUPON_CODES">
		<FormTextFieldWithBtn
			id="redeemCode"
			:key="cartId + appliedCredits.length + (hasAppliedPromocode ? 1 : 0)"
			:label="$t('redeemCodeFieldLabel')"
			:placeholder="$t('redeemCodeFieldPlaceholder')"
			:btn-label="$t('apply')"
			:disable-autocomplete="true"
			:tooltip-msg="$t('redeemCodeFieldTooltip')"
			@input="inputChanged"
			@clicked="applyCode" />
	</div>
</template>

<script setup>
	import { useNuxtApp } from "#app"
	import { useI18n } from "vue-i18n"
	import { useCartStore } from "~/stores/CartStore"
	import { storeToRefs } from "pinia"
	import { SHOW_ERROR } from "assets/events/errors.js"

	const runtimeConfig = useRuntimeConfig()
	const { $cartService, $eventBus } = useNuxtApp()
	const { t } = useI18n()
	const cartStore = useCartStore()
	const { cartId, appliedPromocode, appliedCredits, installments } = storeToRefs(cartStore)

	const redeemValue = ref("")

	const inputChanged = ({ value }) => {
		redeemValue.value = value
	}

	const applyCode = (value) => {
		const code = String(value?.value || "").trim()
		if (!cartId.value) {
			$eventBus.$emit(SHOW_ERROR, {
				titleText: t("tryAgain"),
				bodyText: t("redeemCodeEmptyCart"),
			})
			return
		}

		if (!code) {
			$eventBus.$emit(SHOW_ERROR, {
				titleText: t("tryAgain"),
				bodyText: t("redeemCodeNoCode"),
			})
			return
		}

		if (amountDueToday.value <= 0) {
			$eventBus.$emit(SHOW_ERROR, {
				titleText: t("tryAgain"),
				bodyText: t("redeemCodeZeroAmount"),
			})
			return
		}

		$cartService.$applyCode(code)
		redeemValue.value = ""
	}

	const hasAppliedPromocode = computed(() => {
		return appliedPromocode.value ? !!appliedPromocode.value.promocode : false
	})

	const amountDueToday = computed(() => {
		return installments.value && installments.value.length ? Number(installments.value[0].amount || 0) : 0
	})
</script>

<style scoped></style>
